
namespace Matrix.Exceptions {

    @Serenity.Decorators.registerClass()
    export class ExceptionPolicyIgnoreGrid extends Serenity.EntityGrid<ExceptionPolicyIgnoreRow, any> {
        protected getColumnsKey() { return ExceptionPolicyIgnoreColumns.columnsKey; }
        protected getDialogType() { return ExceptionPolicyIgnoreDialog; }
        protected getIdProperty() { return ExceptionPolicyIgnoreRow.idProperty; }
        protected getInsertPermission() { return ExceptionPolicyIgnoreRow.insertPermission; }
        protected getLocalTextPrefix() { return ExceptionPolicyIgnoreRow.localTextPrefix; }
        protected getService() { return ExceptionPolicyIgnoreService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}